import ReconnectingEventSource, { EventSourceNotAvailableError } from './reconnecting-eventsource';
Object.assign(globalThis, {
  ReconnectingEventSource,
  EventSourceNotAvailableError,
});
